import { render, staticRenderFns } from "./QueryData.vue?vue&type=template&id=783881c2&scoped=true&"
import script from "./QueryData.vue?vue&type=script&lang=js&"
export * from "./QueryData.vue?vue&type=script&lang=js&"
import style0 from "./QueryData.vue?vue&type=style&index=0&id=783881c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783881c2",
  null
  
)

export default component.exports